import { mapTo } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { StorageActions, StorageMsg } from '@wearejh/m2-pwa-engine/lib/storage';

import { CartActions, STORAGE_KEY_CART } from '../cart.actions';

/**
 * Listen for the cart being reset
 *
 * When that happens, also clear any localstorage data
 *
 * @param action$
 */
export function cartReset(action$: Observable<any>) {
    return action$.pipe(ofType<CartActions>('Cart.Reset'), mapTo(StorageMsg(StorageActions.Delete, STORAGE_KEY_CART)));
}
